import { Link } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function NewsSection() {
  const news = [
    {
      id: 1,
      title: 'Tecnutri lança nova linha de produtos para sobremesas',
      excerpt: 'Conheça nossa nova linha de produtos especialmente desenvolvida para criar sobremesas incríveis e práticas.',
      image: 'https://readdy.ai/api/search-image?query=professional%20pastry%20chef%20preparing%20elegant%20desserts%20in%20commercial%20kitchen%2C%20modern%20dessert%20presentation%2C%20food%20service%20industry%2C%20high%20quality%20ingredients%2C%20professional%20culinary%20environment&width=800&height=600&seq=news1&orientation=landscape',
      date: '15 de Janeiro, 2026',
      category: 'Lançamentos'
    },
    {
      id: 2,
      title: 'Dicas para otimizar o uso de produtos em pó no seu negócio',
      excerpt: 'Aprenda as melhores práticas para armazenamento e utilização de produtos em pó, garantindo qualidade e economia.',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/2c79a3a6ab1c4cb10f07ebbc089640c8.jpeg',
      date: '10 de Janeiro, 2026',
      category: 'Dicas'
    },
    {
      id: 3,
      title: 'Tecnutri&nbsp;treinamentos com os clientes&nbsp;food service do Brasil',
      excerpt: 'A Tecnutri quer ser mais que uma simples fornecedora de produtos, queremos ser sua parceira no desenvolvimento do seu negócio.',
      image: 'https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/78604d84acb680cdeb1ec830c9be7ab5.jpeg',
      date: '5 de Janeiro, 2026',
      category: 'Eventos'
    }
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
            Notícias e Novidades
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Fique por dentro das últimas novidades, dicas e tendências do mercado de food service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {news.map((item) => (
            <Card key={item.id} hover className="group">
              <div className="aspect-video mb-4 overflow-hidden rounded-lg bg-gray-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-sm text-gray-500">
                  <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full">
                    {item.category}
                  </span>
                  <span className="flex items-center">
                    <i className="ri-calendar-line mr-1"></i>
                    {item.date}
                  </span>
                </div>
                
                <h3 className="font-semibold text-xl text-gray-900 group-hover:text-red-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                
                <p className="text-gray-600 line-clamp-3">
                  {item.excerpt}
                </p>
                
                <Link 
                  to="/noticias" 
                  onClick={scrollToTop}
                  className="inline-flex items-center text-red-600 font-medium hover:text-red-700 transition-colors"
                >
                  Leia Mais
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Link to="/noticias" onClick={scrollToTop}>
            <Button size="lg" variant="outline">
              Ver Todas as Notícias
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
